var mp = mp || {};